import React, { useState, useEffect } from 'react';
import {
  Drawer,
  Stack,
  Box,
  Typography,
  IconButton,
  Button,
  Divider,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ReactComponent as HomeIconSvg } from '../../assets/Home.svg';
import { ReactComponent as ChatIcon } from '../../assets/Chat_alt_3.svg';
import { ReactComponent as MenuIcon } from '../../assets/MENU.svg';
import { ReactComponent as ProfileIcon } from '../../assets/User_cicrle.svg';
import { ReactComponent as DashboardIcon } from '../../assets/darhboard_alt.svg';
import { ReactComponent as GlobeIcon } from '../../assets/globe.svg';
import { ReactComponent as GlobeIcon2 } from '../../assets/svgviewer-output (1).svg';
import { ReactComponent as BoxIcon } from '../../assets/Box.svg';
import { ReactComponent as LogOutIcon } from '../../assets/Sign_out_circle.svg';
import { logoutUser } from '../../redux/slices/userSlice';
import mapItLogoSvg from '../../utilities/dummy_assets/svgs/MapIt_Logo.svg';
import MessagesIcon from 'components/icons/MessagesIcon';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const MobileSidebar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.style.paddingBottom = '64px';
    return () => (document.body.style.paddingBottom = '0px');
  }, []);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login');
  };

  const handleBottomNav = (path) => {
    setOpen(false);
    navigate(path);
  };

  const MenuButton = ({ icon, label, path, onClick }) => (
    <Button
      fullWidth
      onClick={() => {
        if (path) navigate(path);
        if (onClick) onClick();
        setOpen(false);
      }}
      sx={{
        height: '80px',
        padding: '28px 24px 28px 16px',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        borderRadius: '16px',
        border: '1px solid #E9E9E9',
        backgroundColor: '#F9FAFE',

        boxShadow: '4px 4px 16px rgba(0, 0, 0, 0.05)',

        textTransform: 'none',

        '&:hover': {
          backgroundColor: '#F9FAFE',
        },
      }}
    >
      {/* LABEL */}
      <Typography
        sx={{
          color: '#273F77',

          fontSize: '16px',
          fontStyle: 'normal',
          fontFamily: 'Supreme,Satoshi, system-ui, sans-serif',
          fontWeight: 500,

          lineHeight: '18px',
        }}
      >
        {label}
      </Typography>

      {/* ICON */}
      <Box
        sx={{
          width: '24px',
          height: '24px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        {React.cloneElement(icon, {
          style: {
            width: '24px',
            height: '24px',
            stroke: '#273F77',
            fill: 'none',
          },
        })}
      </Box>
    </Button>
  );

  return (
    <>
      {/* FULL SCREEN MENU */}
      <Drawer
        anchor='bottom'
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            height: '100vh',
            borderRadius: 0,
            backgroundColor: '#FFFFFF',
          },
        }}
      >
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              px: 3,
              py: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid #EEE',
            }}
          >
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>MIS</Typography>
          </Box>
          {/* MENU ITEMS */}
          <Stack spacing={2} px={2} py={3}>
            <MenuButton
              path='/dashboard'
              icon={<DashboardIcon />}
              label='DASHBOARD'
            />
            {/* <MenuButton
              path='/new-dashboard'
              icon={<DashboardIcon />}
              label='MY DASHBOARD'
            /> */}
            <MenuButton path='/explore' icon={<GlobeIcon />} label='EXPLORE' />
            <MenuButton
              path='/projects'
              icon={<DashboardIcon />}
              label='PROJECTS'
            />
            <MenuButton
              path='/records'
              icon={<DashboardIcon />}
              label='RECORDS'
            />
            <MenuButton path='/training' icon={<BoxIcon />} label='TRAINING' />

            <Box
              display='flex'
              flexDirection='row'
              alignItems='center'
              sx={{ px: 2, mt: 3, mb: 1 }}
            >
              <Typography
                variant='caption'
                sx={{
                  color: '#90a4ae',
                  fontWeight: 600,
                  letterSpacing: '0.5px',
                }}
              >
                AI LAYER
              </Typography>

              <Box
                sx={{
                  ml: 1,
                  bgcolor: '#3b82f6',
                  color: 'white',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  px: 1,
                  py: 0.5,
                  borderRadius: '999px',
                }}
              >
                <AutoAwesomeIcon fontSize='10px' /> {'  '}
                New
              </Box>
            </Box>

            <Divider sx={{ mx: 2, bgcolor: 'rgba(255,255,255,0.1)', my: 1 }} />
            <MenuButton
              path='/messages'
              icon={<MessagesIcon color='#fff' />}
              label='Chat & Copilot'
            />
            <Divider sx={{ mx: 2, bgcolor: 'rgba(255,255,255,0.1)', my: 1 }} />
            <MenuButton
              path='/settings'
              icon={<SettingsOutlinedIcon />}
              label='SETTINGS'
            />
            <Divider sx={{ mx: 2, bgcolor: 'rgba(255,255,255,0.1)', my: 1 }} />
            <MenuButton
              icon={<LogOutIcon />}
              label='LOGOUT'
              onClick={handleLogout}
            />
          </Stack>

          {/* FOOTER */}
          <Box
            sx={{
              mt: 'auto',
              pb: '96px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-end',
            }}
          >
            <Box
              sx={{
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              <Typography sx={{ fontSize: '14px', color: '#7A7A7A' }}>
                Powered By
              </Typography>

              <Box
                component='img'
                src={mapItLogoSvg}
                alt='MapIt'
                sx={{ height: 48 }}
              />
            </Box>
          </Box>
        </Box>
      </Drawer>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',

          display: 'flex',
          width: '100%',
          maxWidth: 360,
          height: 64,
          px: '20px',
          py: '12px',

          justifyContent: 'space-between',
          alignItems: 'center',

          bgcolor: '#FFF',
          zIndex: 2000,
          borderTop: '1px solid rgba(0,0,0,0.05)',
        }}
      >
        {/* HOME */}

        <Stack
          alignItems='center'
          justifyContent='center'
          onClick={() => handleBottomNav('/dashboard')}
          sx={{ cursor: 'pointer' }}
        >
          <HomeIconSvg
            style={{
              width: 24,
              height: 24,
              stroke: '#2B2B2B',
            }}
          />
        </Stack>

        {/*chat*/}

        <Stack
          alignItems='center'
          justifyContent='center'
          onClick={() => handleBottomNav('/messages')}
          sx={{ cursor: 'pointer' }}
        >
          <ChatIcon
            style={{
              width: 24,
              height: 24,
              color: '#2B2B2B',
            }}
          />
        </Stack>

        {/* MENU */}
        <Stack
          alignItems='center'
          spacing={0.5}
          onClick={() => setOpen((prev) => !prev)}
        >
          <MenuIcon
            style={{
              width: 46,
              height: 46,
              borderRadius: 2,

              display: 'grid',
              placeItems: 'center',
              cursor: 'pointer',
            }}
          />
        </Stack>

        {/* Setting */}
        {/* Explore */}
        <Stack
          alignItems='center'
          justifyContent='center'
          onClick={() => handleBottomNav('/explore')}
          sx={{ cursor: 'pointer' }}
        >
          <GlobeIcon2
            style={{
              width: 24,
              height: 24,
            }}
          />
        </Stack>

        <Stack
          alignItems='center'
          justifyContent='center'
          onClick={() => handleBottomNav('/profile')}
          sx={{ cursor: 'pointer' }}
        >
          <ProfileIcon
            style={{
              width: 24,
              height: 24,
              color: '#2B2B2B',
            }}
          />
        </Stack>
      </Box>
    </>
  );
};

export default MobileSidebar;
